import BaseService from "./BaseService";

class AuthService extends BaseService {

  constructor(prefix) {
    super(prefix);
  }

  getArtistBannerByArtistId(artist_id, loadingInterval = false) {
    let url = `get-by-artist-id/${artist_id}`
    return this.performRequest(BaseService.METHOD_GET, url, {}, {}, { showLoadingInterval: loadingInterval });
  }
}

export default new AuthService('artist-banners');
